export default class NoteService {

    majorScales = [
        {s:'F major', n:['F','G','A','Bb','C','D','E']},
        {s:'C major', n:['C','D','E','F','G','A','B']},
        {s:'G major', n:['G','A','B','C','D','E','F#']},
        {s:'D major', n:['D','E','F#','G','A','B','C#']},
        {s:'A major', n:['A','B','C#','D','E','F#','G#']},
        {s:'E major', n:['E','F#','G#','A','B','C#','D#']},
        {s:'B major', n:['B','C#','D#','E','F#','G#','A#']},      // Same as Cb major
        {s:'Gb major', n:['Gb','Ab','Bb','Cb','Db','Eb','F']},    // Same as F# major
        {s:'Db major', n:['Db','Eb','F','Gb','Ab','Bb','C']},     // Same as C# major
        {s:'Ab major', n:['Ab','Bb','C','Db','Eb','F','G']},
        {s:'Eb major', n:['Eb','F','G','Ab','Bb','C','D']},
        {s:'Bb major', n:['Bb','C','D','Eb','F','G','A']},
    ]

    // Could also call the sharps flats.
    minorScales = [
        {s:'D minor', n:['D','E','F','G','A','Bb','C']},
        {s:'A minor', n:['A','B','C','D','E','F','G']},
        {s:'E minor', n:['E','F#','G','A','B','C','D']},
        {s:'B minor', n:['B','C#','D','E','F#','G','A']},
        {s:'F# minor', n:['F#','G#','A','B','C#','D','E']},
        {s:'C# minor', n:['C#','D#','E','F#','G#','A','B']},
        {s:'G# minor', n:['G#','A#','B','C#','D#','E','F#']},
        {s:'Eb minor', n:['Eb','F','Gb','Ab','Bb','Cb','Db']},
        {s:'Bb minor', n:['Bb','C','Db','Eb','F','Gb','Ab']},
        {s:'F minor', n:['F','G','Ab','Bb','C','Db','Eb']},
        {s:'C minor', n:['C','D','Eb','F','G','Ab','Bb']},
        {s:'G minor', n:['G','A','Bb','C','D','Eb','F']},
    ]

    constructor() {

    }

    chooseRandomScale() {
        let scale = Math.floor(Math.random() * 2);
        if (scale === 0) {
            return this.majorScales[Math.floor(Math.random() * this.majorScales.length)];
        }
        else {
            return this.minorScales[Math.floor(Math.random() * this.minorScales.length)];
        }
    }

}

